import "./Checkout_Desktop.css";
import SketchComponent from "../components/desktop/Draggable/draggableHome";
import useCheckoutLogic from "../hooks/useCheckoutLogic";
import BillingFormFields from "./shared/BillingFormFields";
import OrderSummaryContent from "./shared/OrderSummaryContent";

const Checkout_Desktop = () => {
  const {
    cartItems,
    isLoading,
    checkoutError,
    formData,
    fieldErrors,
    handleInputChange,
    isFormValid,
    shippingCost,
    total,
    countries,
    handleSubmit,
    handlePayment,
    closeCheckoutError,
  } = useCheckoutLogic();

  return (
    <form className="checkout-form" onSubmit={handleSubmit}>
      <div className="div-container-checkout-all">
        <div className="checkout-left-side">
          <div className="ct-billing-sketch">
            <div className="billing-shipping">
              <BillingFormFields
                formData={formData}
                fieldErrors={fieldErrors}
                handleInputChange={handleInputChange}
                countries={countries}
              />
            </div>
            <div className="ct-imgs-check">
              <SketchComponent />
            </div>
          </div>
        </div>

        <div className="checkout-overview-order">
          <OrderSummaryContent
            cartItems={cartItems}
            formData={formData}
            shippingCost={shippingCost}
            total={total}
            isFormValid={isFormValid}
            handlePayment={handlePayment}
            isLoading={isLoading}
            checkoutError={checkoutError}
            closeCheckoutError={closeCheckoutError}
            isMobile={false}
          />
        </div>
      </div>
    </form>
  );
};

export default Checkout_Desktop;
